const TaskTemplateFieldDefaults = {
  priority: 1,
  deadline: 0,
  assignedGroup: '',
  id: '',
  apps: [],
  prompt: '',
  deadlineRequired: false,
  type: null,
  name: '',
  website: null
};

function getTaskTemplateClass($http, $log) {
  return class TaskTemplate {
    constructor(data) {
      Object.assign(this, { ...TaskTemplateFieldDefaults }, data);
    }

    static async search({ name, ...pagination } = { page: 0, size: 20 }) {
      try {
        const params = { ...pagination };
        // Strip out invalid lead characters
        if (name) params.name = name.replace(/^\?|\\/g, '');

        const { data } = await $http.get('api/tasks/templates', { params });
        return data.results.map(result => new TaskTemplate(result));
      } catch (error) {
        $log.error('Error searching for task templates:\n', error);
        return [];
      }
    }
  };
}

const TaskTemplateFactoryArray = [
  '$http',
  '$log',
  getTaskTemplateClass
];

export { TaskTemplateFieldDefaults };

export default function (ngModule) {
  ngModule.factory('TaskTemplate', TaskTemplateFactoryArray);
}
